import React, { useState, useEffect } from "react"

// import actions
import { connect } from 'react-redux';
import {
  setAllMerchants
} from "../../store/cms-actions/postActions";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"

//Import bootstrap files
import { Row, Col, Card, CardBody, Form, Label, CardImg } from "reactstrap"

//Import React Select
import Select from "react-select"

//Import lodash
import _ from "lodash"

import URLSearchParams from '@ungap/url-search-params'

const SelectMerchant = (props) => {
  const [token, setToken] = useState('')
  const [merchantOptions, setMerchantOptions] = useState([])
  const [selectedMerchant, setSelectedMerchant] = useState([])

  useEffect(() => {
    const token = localStorage.getItem("AuthenticationToken")
    setToken(token)
    getMerchants(token)
    return () => {
    }
  }, [])

  let merchantOptionGroup = []

  const getMerchants = async (token) => {
    let auth = "Bearer " + token
    let _headers = {
      "Content-Type": "application/x-www-form-urlencoded",
      "Authorization": auth
    }
    var requestOptions = {
      method: 'GET',
      headers: _headers,
      redirect: 'follow'
    };
    await fetch(`${process.env.REACT_APP_TOKRI_API_URL}/api/merchants?pageSize=-1`, requestOptions)
      .then(response => response.text())
      .then(result => {
        let _data = JSON.parse(result)
        let tempArr = _.sortBy(_data, 'username')
        tempArr?.length > 0 && tempArr.map((item, index) => {
          if (item.username !== '' && item.external_id !== '' && item.username.toLowerCase() !== "frx delivery") {
            merchantOptionGroup[index] = { label: `${item?.username} (${item?.email})`, value: item?.external_id, email: item?.email }
          }
        })
        setMerchantOptions(merchantOptionGroup)
      })
      .catch(error => console.log('error', error));
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    let token = localStorage.getItem("AuthenticationToken")
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    myHeaders.append("Authorization", "Bearer " + token);
    var urlencoded = new URLSearchParams();
    urlencoded.append("name", selectedMerchant[0]?.label);
    urlencoded.append("email", selectedMerchant[0]?.email);
    urlencoded.append("external_id", selectedMerchant[0]?.value);

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: urlencoded,
      redirect: 'follow'
    };
    fetch(`${process.env.REACT_APP_TOKRI_API_URL}/api/auth/sso`, requestOptions)
      .then(response => response.json())
      .then(result => {
        console.log("Checking response of SSO", result)
        if (result.token) {
          localStorage.setItem("merchantToken", result.token)
          props?.history?.push("/merchant-dashboard")
        }
      })
      .catch(error => console.log('Merchant Login Error', error));
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="" breadcrumbItem="Select Merchant" />

          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <Row>
                    <Col lg={10} md={10} sm={10}>
                      <div className="mt-5 mt-lg-4">
                        <Form
                          className=""
                          method="post"
                          id="tooltipForm"
                          style={{ marginBottom: 170 }}>
                          <div>
                            <Row>
                              <Col lg={4} md={6} sm={6}>
                                <div className="mb-3">
                                  <Label>Merchant</Label>
                                  <Select
                                    isSearchable={true}
                                    maxMenuHeight={190}
                                    menuPlacement="auto"
                                    options={merchantOptions}
                                    onChange={(e) => {
                                      setSelectedMerchant([e])
                                    }}
                                    placeholder={selectedMerchant?.length > 0 && selectedMerchant}
                                    defaultValue={merchantOptions?.length > 0 && merchantOptions[0]?.label}
                                    required
                                  />
                                </div>
                              </Col>
                              <Col lg={2} md={2}>
                                <div className="d-print-none d-table mt-4">
                                  <div className="float-end" >
                                    <div
                                      onClick={(e) => {
                                        if (selectedMerchant?.length > 0) {
                                          handleSubmit(e)
                                        } else {
                                          alert("Please select merchant")
                                        }
                                      }}
                                      style={{ marginTop: 5 }}
                                      className="btn btn-success w-md waves-effect waves-light">Login</div>
                                  </div>
                                </div>
                              </Col>
                              <Col md={6}>

                              </Col>
                            </Row>
                          </div>
                        </Form>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  )
}

const mapStateToProps = (state) => {
  const { allMerchants } = state.rootReducers1
  return { allMerchants }
};

const actions = {
  setAllMerchants,
};

export default connect(mapStateToProps, actions)(SelectMerchant)

